import { render, staticRenderFns } from "./EditRealEstate.vue?vue&type=template&id=cbb5c4fc&"
import script from "./EditRealEstate.vue?vue&type=script&lang=js&"
export * from "./EditRealEstate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports